window.addEventListener('load', function() {
  let headerHight = $('.header').outerHeight();

  // リンク先の details（またはその子孫）を開いてからスクロールする共通処理
  function openTargetDetails($target) {
    if (!$target || !$target.length) return;
    $target.parents('details').addBack('details').each(function() {
      if (!this.open) this.open = true;
    });
  }

  function scrollToTarget($target, headerHight, adjust, speed) {
    if (!$target || !$target.length) return;
    let extra = $target.closest('details').length ? 50 : 0; // summary分
    let position = $target.offset().top + adjust - headerHight - extra;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
  }

  // hrefが「同一ページ内のリンクか」を判定
  // 例: "#aaa" → 同一ページ / "/#aaa" "/pages/contact#aaa" → パス比較で判定
  function isSamePageHash(href) {
    if (!href || href.indexOf('#') === -1) return false;

    // "#aaa" のような形式はそのまま同一ページ扱い
    if (href.charAt(0) === '#') return true;

    // "/pages/contact#aaa" や "https://example.com/pages/contact#aaa" などをURLとして解析
    let url;
    try {
      url = new URL(href, location.href);
    } catch (e) {
      return false;
    }

    // オリジンとパスが現在のページと一致していれば同一ページ内リンクとみなす
    return url.origin === location.origin && url.pathname === location.pathname;
  }


  // --- ページロード時：#付きURLで遷移してきた場合（別ページからでもOK） ---
  if (location.hash) {
    let $target = $(location.hash);
    if ($target.length) {
      openTargetDetails($target);
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          scrollToTarget($target, headerHight, 0, 0);
        });
      });
    }
  }

  // --- リンククリック時 ---
  $('a.smooth').on('click', function(e) {
    let href = $(this).attr('href');

    // 別ページへのリンク（"/pages/contact#aaa" 等）はブラウザ標準の遷移に任せる
    // → 遷移先ページのload時処理（上記）がhashを見て開閉・スクロールを行う
    if (!isSamePageHash(href)) {
      return; // preventDefaultしない = 通常通りページ遷移させる
    }

    e.preventDefault();

    let adjust = 0;
    let speed = 500;
    // "/pages/contact#aaa" 形式でも同一ページと判定された場合はhash部分だけ取り出す
    let hash = href.indexOf('#') === -1 ? '' : '#' + href.split('#')[1];
    let $target = $(hash === '#' || hash === '' ? 'html' : hash);

    openTargetDetails($target);

    requestAnimationFrame(function() {
      scrollToTarget($target, headerHight, adjust, speed);
    });
  });
});

window.addEventListener('load', function() {
  var $details = $('.header__secondary-nav details');
  var $second = $details.eq(1);
  var SP_MAX = 989;

  function isSP() {
    return window.innerWidth <= SP_MAX;
  }

  function syncPC() {
    if (isSP()) {
      $details.each(function() {
        if (this.open) this.open = false;
      });
    } else {
      if (!$second[0].open) $second[0].open = true;
    }
  }

  syncPC();

  $details.on('toggle', function() {
    if (isSP()) {
      if (this.open) {
        $details.not(this).each(function() {
          if (this.open) this.open = false;
        });
      }
    } else {
      if (this === $second[0] && !this.open) {
        this.open = true;
      }
    }
  });

  $(window).on('resize', function() {
    clearTimeout(window.__navResizeTimer);
    window.__navResizeTimer = setTimeout(syncPC, 150);
  });
});